import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';

import { type Appointment as AppointmentResponse } from '../../types';

export interface PatientConfirmedStatusProps {
  appointment: AppointmentResponse;
}

/**
 * Displays a visual indicator when a patient has confirmed their appointment.
 * Shows a green check icon with "Patient Confirmed" text.
 */
export const PatientConfirmedStatus: React.FC<PatientConfirmedStatusProps> = ({ appointment }) => {
  // Only show if patient has confirmed
  if (appointment.confirmation_status !== 'confirmed') {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <CheckCircleIcon sx={{ fontSize: 18, color: '#33E081' }} />
      <Typography variant="body2">Patient Confirmed</Typography>
    </Box>
  );
};
